import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  Finance,
  Department,
  Dashboard,
  Projects,
  Certificate,
  Employees,
  Calendar,
  Heart,
  Question,
  Shield,
  Category as CategoryIcon,
  EmployeeManagement,
  Reporting,
  ArrowRight,
  User,
  Book,
  Email,
  Location,
  CommunicationFeedback,
  Tickets,
} from "@/components/icons";
import type { ReportCatalogEntry } from "../constants/report-catalog";
import styles from "./ReportCategoryCard.module.scss";

// Tüm kart ikonları line-art / stroke-based aynı stilde. "approve" (solid
// yeşil daire + tick) stil olarak uyumsuz kaldığı için Certificate line-art
// ile değiştirildi; ayrıca katalogda kullanılıp map'te eksik olan "reporting"
// de eklendi (yoksa Dashboard fallback'a düşüyordu).
const ICON_MAP: Record<string, React.ComponentType<{ width?: number; height?: number }>> = {
  finance: Finance,
  department: Department,
  dashboard: Dashboard,
  projects: Projects,
  certificate: Certificate,
  employees: Employees,
  employeeManagement: EmployeeManagement,
  calendar: Calendar,
  heart: Heart,
  question: Question,
  shield: Shield,
  assetCategory: CategoryIcon,
  reporting: Reporting,
  user: User,
  book: Book,
  mail: Email,
  location: Location,
  communicationFeedback: CommunicationFeedback,
  support: Tickets,
};

interface ReportCategoryCardProps {
  report: ReportCatalogEntry;
}

const ReportCategoryCard: React.FC<ReportCategoryCardProps> = ({ report }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const Icon = ICON_MAP[report.iconName] ?? Dashboard;

  const handleClick = () => {
    navigate(report.route);
  };

  return (
    <button
      type="button"
      className={styles.card}
      onClick={handleClick}
      aria-label={report.title}
    >
      <div className={styles.iconWrap}>
        <Icon width={22} height={22} />
      </div>
      <div className={styles.body}>
        <div className={styles.titleRow}>
          <h4 className={styles.title}>{report.title}</h4>
          {!report.isImplemented && (
            <span className={styles.badgeSoon}>{t("reportCategoryCard.comingSoon")}</span>
          )}
        </div>
        <p className={styles.description}>{report.description}</p>
      </div>
      <div className={styles.chevron} aria-hidden>
        <ArrowRight width={18} height={18} />
      </div>
    </button>
  );
};

export default ReportCategoryCard;
